import React, { useState } from 'react';
import Styles from '../styles/Lifecycle.module.css';
import { Flex, Button, AddIcon, ThemePrepared, Grid } from '@fluentui/react-northstar';
import { cloneDeep } from 'lodash';
import { PhasePowerAutomateTask } from './PhasePowerAutomateTask';
import { KeyValuePair, LifecyclePowerAutomateTask, RelationshipData } from '../utils/typings';
import { PhasePowerAutomateTaskDialog } from './PhasePowerAutomateTaskDialog';
import { getNewGuid } from '../utils/helper';
import { LIFECYCLE } from '../../shared/utils/constants'

interface Props {
  data: LifecyclePowerAutomateTask[];
  updateData: (data: LifecyclePowerAutomateTask[]) => void;
  globalTheme: ThemePrepared<any>;
  phaseData: RelationshipData;
  userList: PlatformUser[];
  showHeading?: boolean;
}

export const PhasePowerAutomateTaskSection = ({
  data,
  updateData,
  globalTheme,
  phaseData,
  userList,
  showHeading
}: Props) => {
  const [openDialog, setOpenDialog] = useState(false);


  const initialTaskData: LifecyclePowerAutomateTask = {
    Id: 0,
    Name: '',
    Guid: '',
    LifecyclePhaseId: phaseData.Id,
    AssigneeId: null,
    Assignee: null,
    IsPowerAutomateTask: true
  }

  let dataClone = cloneDeep(data);

  const updateTaskData = (editData: KeyValuePair[], index: number) => {
    editData.forEach(pair => {
      if(pair.key == "RemoveItem")
        dataClone.splice(index, 1);
      else
        dataClone[index][pair.key] = pair.value;
    });    
    updateData(dataClone);
  }

  const saveNewTask = (newTask: LifecyclePowerAutomateTask) => {
    newTask.Guid = getNewGuid();
    data.push(newTask);
    
    updateData(data);
  }

  let taskAndapprovalBorderStyle = 'mb-4 mt-4';
  if(showHeading){
      taskAndapprovalBorderStyle = Styles.taskAndapprovalBorder;
  }

  return (
    <>
     <div className={taskAndapprovalBorderStyle}>
        <Flex space={`between`} vAlign={'center'}>
            <Flex.Item><h2 className={Styles.SubHeading2} style={{marginBottom: '0px'}}>{LIFECYCLE.POWER_AUTOMATE_TASKS}</h2></Flex.Item>
          <Flex.Item>
            <Button
              icon={<AddIcon 
                  styles={{color: globalTheme.siteVariables.colorScheme.brand.foreground}} 
                  />}
              text
              primary
              content={<span 
                  style={{color: globalTheme.siteVariables.colorScheme.brand.foreground}}
                  >{LIFECYCLE.ADD_FLOW}</span>}
                onClick={() => {
                  setOpenDialog(true);
                }}
              />
          </Flex.Item>
        </Flex>
        <div className={`${Styles.TicketsContainer}`}>
          <Grid columns={data.length === 1 ? 1: 2}>
            {data.map((item, index) => {
                return (
                <div key={item.Id}>
                  <PhasePowerAutomateTask
                    data={item}
                    dataIndex={index}
                    updateData={updateTaskData}
                    globalTheme={globalTheme}
                    userList={userList}
                  />
                </div>)
            })}
          </Grid>
        </div>
        <PhasePowerAutomateTaskDialog
                open={openDialog}
                onCancel={() => setOpenDialog(false)}
                saveTask={saveNewTask}
                initData={initialTaskData}
                userList={userList}
            />        
    </div>
    </>
  );

};
